import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Overlay, CheckBox } from "../..";

// * Styles
import "../../../styles/login.scss";

// * Images
import { ReactComponent as CloseSvg } from "../../../assets/auth/login-close.svg";
import SignUpForm from "./Form";
import OTP from "./OTP";
import SignUpContext from "./SignUpContext";

const STEP = {
  FORM: 1,
  OTP: 2,
};

const SignUp = (props) => {
  // * Props
  const { onSwitch, onClose, onNavigateToOnboard, onForgotPassword } = props;

  const [step, setStep] = useState(STEP.FORM);
  const [registrationId, setRegistrationId] = useState(undefined);
  const [credentials, setCredentials] = useState(undefined);

  // * Mount
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDownEvent, false);

    return () => {
      document.removeEventListener("keydown", handleKeyDownEvent, false);
    };
  }, []);

  const handleKeyDownEvent = (e) => {
    if ((e.key ?? "").toString().toLowerCase() !== "escape") return;
    handleClose();
  };

  const handleForgotPassword = () => onForgotPassword();

  const handleSignUp = () => {
    setStep(STEP.OTP);
  };

  const handleOtpConfirm = () => {
    // * Set localStorage for later use in Onboard
    localStorage.setItem("onboard:credentials", JSON.stringify(credentials));
    localStorage.setItem("onboard:registration-id", registrationId);

    onNavigateToOnboard();
  };

  const contextValues = useMemo(
    () => ({
      registrationId,
      setRegistrationId,
      credentials,
      setCredentials,
    }),
    [registrationId]
  );

  return (
    <SignUpContext.Provider value={contextValues}>
      <Overlay
        onClose={onClose}
        content={
          <div className="login">
            {step === STEP.FORM && (
              <SignUpForm
                onSignUp={handleSignUp}
                onSwitch={onSwitch}
                onForgotPassword={handleForgotPassword}
                onNavigateToOnboard={onNavigateToOnboard}
                onClose={onClose}
              />
            )}
            {step === STEP.OTP && <OTP onContinue={handleOtpConfirm} />}
          </div>
        }
      ></Overlay>
    </SignUpContext.Provider>
  );
};

SignUp.propTypes = {
  onClose: PropTypes.func,
  onSwitch: PropTypes.func,
  onSignUp: PropTypes.func,
  onNavigateToOnboard: PropTypes.func,
  onForgotPassword: PropTypes.func,
};

SignUp.defaultProps = {
  onClose: () => {},
  onSwitch: () => {},
  onSignUp: () => {},
  onNavigateToOnboard: () => {},
  onForgotPassword: () => {},
};

export default SignUp;
